var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "branding") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-1641.000000, -869.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "branding",
    transform: "translate(1641.000000, 869.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 451,
    cy: 244,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Design_line_bb",
    transform: "translate(101.000000, 91.000000)",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 45.4385965 72.7272727 45.4385965 72.7272727 118.140351 0 118.140351"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "236.363636 45.4385965 309.090909 45.4385965 309.090909 118.140351 236.363636 118.140351"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.7272727,
    y1: 81.7894737,
    x2: 236.363636,
    y2: 81.7894737,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.3636364,
    y1: 118.140351,
    x2: 36.3636364,
    y2: 308.982456,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 308.982456 72.7272727 308.982456 72.7272727 381.684211 0 381.684211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "236.363636 308.982456 309.090909 308.982456 309.090909 381.684211 236.363636 381.684211"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.7272727,
    y1: 345.333333,
    x2: 236.363636,
    y2: 345.333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.727273,
    y1: 118.140351,
    x2: 272.727273,
    y2: 165.914491,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.727273,
    y1: 308.982456,
    x2: 272.727273,
    y2: 263.98007,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.818182,
    y1: 0,
    x2: 381.818182,
    y2: 45.4385965,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 118.140351,
    x2: 454.545455,
    y2: 118.140351,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.272727,
    y1: 518,
    x2: 227.272727,
    y2: 472.561404,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.090909,
    y1: 399.859649,
    x2: 154.545455,
    y2: 399.859649,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.427273,137.097333 L158.336364,200.711368 C150.881818,202.983298 145.454545,209.90814 145.454545,218.105263 C145.454545,220.104561 146.381818,223.857789 146.381818,223.857789 L164.554545,278.356842 C166.954545,285.590667 173.772727,290.807018 181.818182,290.807018 C183.7,290.807018 187.118182,290.025474 187.118182,290.025474 L396.209091,226.411439 C403.672727,224.139509 409.090909,217.214667 409.090909,209.017544 C409.090909,206.981895 408.754545,205.018947 408.136364,203.192316 L389.990909,148.775053 C387.590909,141.53214 380.772727,136.315789 372.727273,136.315789 C370.845455,136.315789 367.427273,137.097333 367.427273,137.097333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "397.936364 172.593965 438.254545 156.008877 461.363636 221.794877 345.454545 318.070175 365.109091 368.579719"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.145455,
    y1: 59.8153684,
    x2: 477.863636,
    y2: 22.1285965,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.209091,466.390842 C374.418182,469.980491 377.818182,472.561404 381.818182,472.561404 C382.827273,472.561404 383.790909,472.397825 384.690909,472.09793 L411.963636,463.010211 C415.581818,461.810632 418.181818,458.402737 418.181818,454.385965 C418.181818,453.36814 418.018182,452.386667 417.7,451.468807 L390.445455,369.73386 C389.245455,366.116947 385.836364,363.508772 381.818182,363.508772 C380.809091,363.508772 379.845455,363.672351 378.945455,363.972246 L351.672727,373.059965 C348.054545,374.259544 345.454545,377.667439 345.454545,381.684211 C345.454545,382.68386 345.618182,383.647158 345.918182,384.546842 L373.209091,466.390842 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.945455,
    y1: 458.184632,
    x2: 131.227273,
    y2: 495.871404,
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ae2a112ec0204384138e467c4a5c8460.svg";
export { ForwardRef as ReactComponent };